import { Injectable } from "@angular/core";

import { isExecutionResult, ToastService } from "@tylertech/core-module";
import { IntentService } from "@tylertech/intents-module";
import { IAggregate, ICardData, ICardAction, ActionType } from "@tylertech/tyler-api-types";

import { IAggregateActionHandler } from "../interfaces/injectionToken";
import { AggregateActionResult } from "../services";
import { HttpErrorResponse } from "@angular/common/http";

// TODO - why does this live here and not in library/intents
@Injectable()
export class IntentActionHandler implements IAggregateActionHandler
{
    constructor(
        private readonly $toastService: ToastService,
        private readonly $intentService: IntentService)
    { }

    predicate(_aggregate: IAggregate, _cardData: ICardData, action: ICardAction): boolean
    {
        return action.actionType === ActionType.Intent;
    }

    execute(_aggregate: IAggregate, _cardData: ICardData, action: ICardAction): Promise<AggregateActionResult>
    {
        if (action.content.substr(0, 6).toLowerCase() === "intent")
        {
            return this.$intentService.resolveURI(action.content)
                .then(
                    r =>
                    {
                        if (!r)
                        {
                            return false;
                        }

                        if (isExecutionResult(r))
                        {
                            this.$toastService.showToast(r.ValidationMessage
                                ? r.ValidationMessage
                                : r.ErrorMessage);

                            //TODO On execution result (approve, reject) return success to determine if the aggregate should disappear
                            return r.Success;
                        }

                        return r;
                    },
                    (err: HttpErrorResponse) =>
                    {
                        this.$toastService.showToast(err.error.Message);
                        return false;
                    }
                );
        }
        else
        {
            const intentLocation = action.content.split("|");
            return this.$intentService.resolve(intentLocation[0], intentLocation[1], action.Model)
                .then(
                    r => r,
                    (err: HttpErrorResponse) => this.$toastService.showToast(err.error.Message));
        }
    }

    load(_aggregate: IAggregate, _cardData: ICardData, _action: ICardAction): void
    {
        /* NO_OP */
    }
}
